export enum BillingPlan {
  // Classic
  ClassicFree = 'free',
  ClassicStarter = 'starter',
  ClassicBusiness = 'business',
  ClassicPremium = 'premium',
  ClassicEnterprise = 'enterprise',

  // Connect
  ConnectTrial = 'connect_trial',
  ConnectBasic = 'basic',
  ConnectPro = 'pro',
  ConnectEnterprise = 'connect_enterprise',
}

export enum ConnectAddOn {
  CustomIntegrationBuilder = 'byo',
  DynamicFieldMapper = 'dfm',
  HeadlessConnectPortal = 'headless-cp',
  TaskHistoryAPI = 'th-api',
  Monitoring = 'monitoring',
  RoleBasedAccessControl = 'rbac',
  UserMetadata = 'user-metadata',
  WhiteLabeling = 'whitelabel',
  WorkflowPermission = 'workflow-permissions',
}

export type ConnectNonTrialBillingPlan =
  | BillingPlan.ConnectBasic
  | BillingPlan.ConnectPro
  | BillingPlan.ConnectEnterprise;
